import './media_boxes.scss';
import { create_div, get_el } from 'js/utils';
import MB_Load_More from './js/load_more';
import MB_Filters from './js/filters';
import MB_Search from './js/search';
import MB_Load_All from './js/load_all';

class FF_Media_Boxes {

    constructor(container){
        this.container = get_el(container);
        this.settings = JSON.parse(this.container.dataset.mb_settings);
        this.show_items_num = this.settings.query_args.showposts || 12;

        this.hooks = {};
        
        this.items_init();
        this.isotope_init();

        this.load_all = new MB_Load_All(this);
        this.filters = new MB_Filters(this);
        this.search = new MB_Search(this);
        this.load_more = new MB_Load_More(this);
    }
    
    items_init(){
        const items = this.container.querySelectorAll('.mb_item');
        this.items_count = items.length;
        this.total = items.length;
    }

    isotope_init(){
        this.items_container = this.container.querySelector('.mb_items');
        this.isotope = new Isotope(this.items_container, {
            itemSelector: '.mb_item',
            layoutMode: 'fitRows',
            transitionDuration: 550,
            hiddenStyle: {
                opacity: 0,
                transform: 'scale(0.9)',
            },
            visibleStyle: {
                opacity: 1,
                transform: 'scale(1)',
            }
        });
    }

    show_minimum_items(){

        let items = this.isotope.filteredItems;

        for( let i = 0; i < items.length; i++ ) {
            
            let item = items[i].element;
            
            item.classList.remove('mb_hidden');

            if( i >= this.show_items_num ) {
                // item.classList.add('mb_hidden')
                break;
            }
        }
        
        this.isotope.layout();
    }
    
    toggle_no_results(){

        let el = this.no_results_el;

        if( !this.isotope.filteredItems.length ) {
        
            if( typeof el === 'undefined' ) {
                let text = this.settings.no_results_text ?? 'No results found, try different filters.';
                el = create_div('mb_no_results', this.container, text);
                this.no_results_el = el;
            }
        
            el.style.display = '';
            return;
        }
        
        if( typeof el !== 'undefined' ) {
            el.style.display = 'none';
        }
    }

    filter(){
        const have_filters = this.filters.have_filters();
        const filter_item = this.filters.filter_item.bind(this.filters);

        const have_search = this.search.search_string !== '';
        const search_regex = new RegExp( this.search.search_string, 'gi' );

        this.isotope.arrange({ filter: function(i,el){
            const filter_result = have_filters ? filter_item(el) : true;
            const search_result = have_search ? el.textContent.match(search_regex) : true;
            return search_result && filter_result;
        }})

        this.show_minimum_items();
        this.toggle_no_results();
    }

}

document.querySelectorAll('.ff_media_boxes').forEach(container=>{
    container.mb = new FF_Media_Boxes(container);
})

// const event = new Event('mb_ready');
// event.init = (container)=>{
//     return new FF_Media_Boxes(container);
// }
// document.dispatchEvent(event);